const INITIAL_STATE = {
    endereco: {},
    enderecos: []
}

export default function Endereco(state = INITIAL_STATE, action) {
    switch(action.type) {
        case 'ENDERECO_FETCHED' :
            return { ...state, endereco: action.payload }
        case 'ENDERECOS_FETCHED' :
            return { ...state, enderecos: action.payload }
        default :
            return state
    }
}